import { Col, Form } from "react-bootstrap";

export default function DurationPicker({ filterData, setFilterData, name, inputOnly = false }) {
    function renderTimePicker(field) {
        const totalSeconds = filterData[field] || 0;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        function update(minutesVal, secondsVal) {
            let m = Math.max(0, Math.min(8, minutesVal));
            let s = Math.max(0, Math.min(59, secondsVal));

            if (m * 60 + s > 480) {
                m = 8;
                s = 0;
            }

            let newValue = m * 60 + s;

            if (field === "minDuration" && newValue > filterData.maxDuration) {
                newValue = filterData.maxDuration;
            }
            if (field === "maxDuration" && newValue < filterData.minDuration) {
                newValue = filterData.minDuration;
            }

            setFilterData({
                ...filterData,
                [field]: newValue,
            });
        }

        const pad = num => String(num).padStart(2, "0");

        return (
            <div className="duration-input">
                <Form.Control type="number" min={0} max={8} value={pad(minutes)} onChange={e => update(Number(e.target.value), seconds)} />
                <Form.Control type="number" min={0} max={59} value={pad(seconds)} onChange={e => update(minutes, Number(e.target.value))} />
            </div>
        );
    }

    const input = (
        <Col className="d-flex align-items-center column-gap-3">
            <div className="d-flex align-items-center">
                <span className="me-1">Min</span>
                {renderTimePicker("minDuration")}
            </div>
            <div className="d-flex align-items-center">
                <span className="me-1">Max</span>
                {renderTimePicker("maxDuration")}
            </div>
        </Col>
    );

    if (inputOnly) return input;

    return (
        <Form.Group as={Col}>
            <Form.Label>Duration (mm:ss)</Form.Label>
            {input}
        </Form.Group>
    );
}
